import React, { useEffect, useState } from 'react';
import { useMount } from 'react-use';
import { useSelector, useStore } from 'react-redux';
import PropTypes from 'prop-types';
import { canUseDOM } from '@surfline/web-common';
import { useModalComputer } from './useModalComputer';
import { rateLimitUserDetails } from '../../../common/metering';
import { getMeteringEnabled, getMeterLoaded } from '../../../selectors/state';

const RegWall = ({ renderOptions: { rateLimitingEnabled } }) => {
  const [ready, setReady] = useState(false);
  const store = useStore();
  const meteringEnabled = useSelector(getMeteringEnabled);
  const meterLoaded = useSelector(getMeterLoaded);
  const modalToRender = useModalComputer();
  const [excludedPath, setExcludedPath] = useState(false);

  useMount(() => {
    if (!meterLoaded && meteringEnabled) {
      rateLimitUserDetails(rateLimitingEnabled, store);
    }
  });

  useEffect(() => {
    if (canUseDOM && rateLimitingEnabled && meterLoaded) {
      setReady(true);
      setExcludedPath(window.location.href.indexOf('surf-reports-forecasts-cams-map') !== -1);
    }
  }, [rateLimitingEnabled, ready, meterLoaded, modalToRender]);

  // When the reg-wall mounts, we want to scroll the page to the top
  useEffect(() => {
    if (ready && modalToRender) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [ready, modalToRender]);

  return (
    <div data-scroll-lock-scrollable>
      {ready && modalToRender && meteringEnabled && !excludedPath ? modalToRender : null}
    </div>
  );
};

RegWall.propTypes = {
  renderOptions: PropTypes.shape({
    rateLimitingEnabled: PropTypes.oneOf(['true', 'false']),
  }),
};

RegWall.defaultProps = {
  renderOptions: PropTypes.shape({}),
};

export default RegWall;
